import { MakeLogicType, kea, key, path, props } from 'kea'
import { loaders } from 'kea-loaders'

import { getCurrentTeamId } from 'lib/utils/getAppContext'

import { signalsReportsList } from 'products/signals/frontend/generated/api'
import type { SignalReportApi } from 'products/signals/frontend/generated/api.schemas'
import { SignalSourceProductApi } from 'products/signals/frontend/generated/api.schemas'

export interface LinkedReportsLogicProps {
    issueId: string
}

const LINKED_REPORTS_LIMIT = 10

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface linkedReportsLogicValues {
    linkedReports: SignalReportApi[]
    linkedReportsLoading: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface linkedReportsLogicActions {
    loadLinkedReports: () => any
    loadLinkedReportsFailure: (
        error: string,
        errorObject?: any
    ) => {
        error: string
        errorObject?: any
    }
    loadLinkedReportsSuccess: (
        linkedReports: SignalReportApi[],
        payload?: any
    ) => {
        linkedReports: SignalReportApi[]
        payload?: any
    }
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface linkedReportsLogicMeta {
    key: string
}

export type linkedReportsLogicType = MakeLogicType<
    linkedReportsLogicValues,
    linkedReportsLogicActions,
    LinkedReportsLogicProps,
    linkedReportsLogicMeta
>

export const linkedReportsLogic = kea<linkedReportsLogicType>([
    props({} as LinkedReportsLogicProps),
    key((props) => props.issueId),
    path((key) => ['products', 'error_tracking', 'scenes', 'ErrorTrackingIssueScene', 'linkedReportsLogic', key]),
    loaders(({ props }) => ({
        linkedReports: [
            [] as SignalReportApi[],
            {
                // Error tracking tags its signals with the issue id as `source_id`, so this filter
                // walks the link from the issue back to the reports its signals fed.
                loadLinkedReports: async (): Promise<SignalReportApi[]> => {
                    try {
                        const response = await signalsReportsList(getCurrentTeamId().toString(), {
                            source_id: props.issueId,
                            source_product: SignalSourceProductApi.ErrorTracking,
                            // The endpoint's default ordering leads with the viewer's own review
                            // queue, which is an inbox concern rather than this pane's.
                            ordering: '-updated_at',
                            limit: LINKED_REPORTS_LIMIT,
                        })
                        return response.results
                    } catch (error) {
                        // Supplementary context, so it degrades quietly: kea-loaders toasts a failed
                        // `load*` action, and a signals outage must not do that on every issue page.
                        console.error('Failed to load linked reports:', error)
                        return []
                    }
                },
            },
        ],
    })),
])
